import React, { Component } from 'react'
import PropTypes from 'prop-types'


class IntersectionObserver extends Component {

  static propTypes = {
    onIntersect: PropTypes.func.isRequired,
  }

  node = null
  observer = null

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  init = (node) => {
    if (!this.node) {
      this.node = node
      this.subscribe()
    }
  }

  subscribe() {
    this.observer = new window.IntersectionObserver(this.handleIntersection, {})

    this.observer.observe(this.node)
  }

  handleIntersection = (entries) => {
    const { onIntersect } = this.props
    const { isIntersecting } = entries[0]

    if (isIntersecting) {
      onIntersect()
      this.observer.disconnect()
    }
  }

  render() {
    const { children } = this.props

    return React.cloneElement(children, {
      ref: this.init,
    })
  }
}


export default IntersectionObserver
